/**
 * flexible.js - 移动端自适应解决方案
 *
 * 功能扩展：支持路由匹配规则，根据不同路由使用不同的 fontSize 计算方式
 *
 * 使用说明：
 * 1. 默认情况下使用原有的 flexible.js 计算规则：rem = width / 10
 * 2. 在 customRoutes 数组中添加需要使用自定义计算规则的路由路径
 * 3. 匹配到的路由将使用 setFontSize 计算规则（基于设计图宽度 920px）
 *
 * 示例：
 * - 添加路由：在第 75 行的 customRoutes 数组中添加路由路径
 *   var customRoutes = ['/veinReport', '/skinReport', '/otherRoute'];
 *
 * 自定义计算规则参数（第 84-88 行）：
 * - DESIGN_WIDTH: 设计图宽度（默认 920px）
 * - BASE_FONT_SIZE: 基准 fontSize（默认 100）
 * - MIN_FONT_SIZE: 最小 fontSize 限制（默认 50）
 * - MAX_FONT_SIZE: 最大 fontSize 限制（默认 75）
 * - MAX_WIDTH: 最大显示宽度（默认 1200）
 */
(function (win, lib) {
  var doc = win.document;
  var docEl = doc.documentElement;
  var metaEl = doc.querySelector('meta[name="viewport"]');
  var flexibleEl = doc.querySelector('meta[name="flexible"]');
  var dpr = 0;
  var scale = 0;
  var tid;
  var flexible = lib.flexible || (lib.flexible = {});
  // 规则覆盖栈：用于在同一路由内（弹窗/嵌套组件）临时切换 rem 计算方式
  // 顶层优先：栈顶的规则会覆盖路由匹配规则，关闭后 pop 恢复，互不干扰
  var remRuleStack = [];
  // 根字号锁：在 override 生效时，防止页面代码覆盖 html font-size
  var rootFontSizeLock = {
    enabled: false,
    desiredPx: null,
    observer: null,
    applying: false,
  };

  if (metaEl) {
    console.warn('将根据已有的meta标签来设置缩放比例');
    var match = metaEl.getAttribute('content').match(/initial-scale=([\d.]+)/);
    if (match) {
      scale = parseFloat(match[1]);
      dpr = parseInt(1 / scale);
    }
  } else if (flexibleEl) {
    var content = flexibleEl.getAttribute('content');
    if (content) {
      var initialDpr = content.match(/initial-dpr=([\d.]+)/);
      var maximumDpr = content.match(/maximum-dpr=([\d.]+)/);
      if (initialDpr) {
        dpr = parseFloat(initialDpr[1]);
        scale = parseFloat((1 / dpr).toFixed(2));
      }
      if (maximumDpr) {
        dpr = parseFloat(maximumDpr[1]);
        scale = parseFloat((1 / dpr).toFixed(2));
      }
    }
  }

  if (!dpr && !scale) {
    // var isAndroid = win.navigator.appVersion.match(/android/gi);
    var isIPhone = win.navigator.appVersion.match(/iphone/gi);
    var devicePixelRatio = win.devicePixelRatio;
    if (isIPhone) {
      // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
      if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
        dpr = 3;
      } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
        dpr = 2;
      } else {
        dpr = 1;
      }
    } else {
      // 其他设备下，仍旧使用1倍的方案
      dpr = 1;
    }
    scale = 1 / dpr;
  }

  docEl.setAttribute('data-dpr', dpr);
  if (!metaEl) {
    metaEl = doc.createElement('meta');
    metaEl.setAttribute('name', 'viewport');
    metaEl.setAttribute(
      'content',
      'initial-scale=' + scale + ', maximum-scale=' + scale + ', minimum-scale=' + scale + ', user-scalable=no',
    );
    if (docEl.firstElementChild) {
      docEl.firstElementChild.appendChild(metaEl);
    } else {
      var wrap = doc.createElement('div');
      wrap.appendChild(metaEl);
      doc.write(wrap.innerHTML);
    }
  }

  function getActiveOverrideRule() {
    if (!remRuleStack.length) return null;
    return remRuleStack[remRuleStack.length - 1];
  }

  function calcRemLibFlexible(width) {
    // 原有的 lib-flexible/flexible.js 计算规则
    var w = width;
    if (w / dpr > 540) {
      w = 540 * dpr;
    }
    return w / 10;
  }

  function calcRemCustom(width) {
    // 自定义计算规则（基于设计图宽度 920px）
    var DESIGN_WIDTH = 920;
    var BASE_FONT_SIZE = 100;
    var MIN_FONT_SIZE = 50;
    var MAX_FONT_SIZE = 75;
    var MAX_WIDTH = 1200;

    var actualWidth = Math.min(width, MAX_WIDTH);
    var fontSize = (actualWidth / DESIGN_WIDTH) * BASE_FONT_SIZE;
    fontSize = Math.max(MIN_FONT_SIZE, Math.min(fontSize, MAX_FONT_SIZE));
    return fontSize;
  }

  function calcRemPcResize(parentWidth) {
    // 对齐 src/utils/util.js 的 pcResize 逻辑：rem = parseInt(width / 19.62)
    // 注意：pcResize 以 body.clientWidth 为准，这里也尽量对齐（避免同一路由内两套取宽导致字号跳变）
    let w = parentWidth || (doc.body && doc.body.clientWidth) || win.innerWidth || docEl.getBoundingClientRect().width;
    return parseInt(w / 19.62, 10);
  }

  function ensureRootFontSizeObserver() {
    if (rootFontSizeLock.observer) return;
    if (!win.MutationObserver) return;
    rootFontSizeLock.observer = new MutationObserver(function () {
      if (!rootFontSizeLock.enabled) return;
      if (rootFontSizeLock.applying) return;
      if (!rootFontSizeLock.desiredPx) return;
      var currentPx = parseFloat(win.getComputedStyle(docEl).fontSize) || 0;
      // 如果被覆盖了，立即回写（带 !important，避免被样式表干扰）
      if (Math.abs(currentPx - rootFontSizeLock.desiredPx) > 0.1) {
        rootFontSizeLock.applying = true;
        try {
          docEl.style.setProperty('font-size', rootFontSizeLock.desiredPx + 'px', 'important');
          flexible.rem = win.rem = rootFontSizeLock.desiredPx;
        } finally {
          rootFontSizeLock.applying = false;
        }
      }
    });
    rootFontSizeLock.observer.observe(docEl, { attributes: true, attributeFilter: ['style'] });
  }

  function lockRootFontSize(px) {
    rootFontSizeLock.enabled = true;
    rootFontSizeLock.desiredPx = px;
    ensureRootFontSizeObserver();
  }

  function unlockRootFontSize() {
    rootFontSizeLock.enabled = false;
    rootFontSizeLock.desiredPx = null;
  }

  function applyRootFontSize(px, lock) {
    if (lock) {
      lockRootFontSize(px);
      docEl.style.setProperty('font-size', px + 'px', 'important');
    } else {
      unlockRootFontSize();
      docEl.style.fontSize = px + 'px';
    }
    // console.log('applyRootFontSize', px);
    flexible.rem = win.rem = px;
  }

  function refreshRem(parentWidth) {
    var width = docEl.getBoundingClientRect().width;

    // pcResize 规则路由：这些页面会在业务里调用 pcResize（更符合 PC 设计稿）
    // 为避免首次渲染字号先按 flexible 后再被 pcResize 改写导致“跳一下”，这里直接让 flexible 使用同一套 pcResize 计算。
    var pcRoutes = ['/skinDetail', '/skinRadar'];

    // 路由匹配规则：需要使用新计算规则的路由列表（与 calcRemCustom 设计稿 920px 一致）
    // 含：经络报告、AI 问答、红外报告、更多建议、私密报告、私密平衡态
    var customRoutes = [
      '/veinReport',
      // '/aiFAQs',
      'aiInfraredReport',
      '/moreSuggestions',
      // '/privacyReport',
      // '/privacyReportImage',
    ];
    var currentPath = win.location.pathname;
    var usePcCalculation = pcRoutes.some(function (route) {
      return currentPath.indexOf(route) !== -1;
    });
    // 1) 先按 path 匹配：命中 customRoutes 则使用自定义计算
    var useCustomCalculation = customRoutes.some(function (route) {
      // return currentPath.indexOf(route) !== -1 || win.location.search.includes('reportType=30');
      return currentPath.indexOf(route) !== -1;
    });
    // 2) 报告页实际多为 /natvip 或 /natvipHistory + reportType 动态渲染，path 并非 /privacyReport
    //    此处根据 URL 的 reportType 补充：23/25/27 对应 PrivacyReport，同样使用自定义计算（设计稿 920px）
    // if (!useCustomCalculation && (currentPath === '/natvip' || currentPath === '/natvipHistory')) {
    //   var reportType = win.location.search ? (win.location.search.match(/[?&]reportType=(\d+)/) || [])[1] : '';
    //   var t = reportType ? parseInt(reportType, 10) : NaN;
    //   if ([23, 25, 27].includes(t)) useCustomCalculation = true;
    // }

    // console.log('useCustomCalculation', useCustomCalculation);

    // 1) 如果存在覆盖规则：直接按覆盖规则计算（不受路由匹配影响）
    var overrideRule = getActiveOverrideRule();
    // console.log('overrideRule', overrideRule);
    if (overrideRule && overrideRule.type) {
      var remOverride;
      // console.log('overrideRule.type', overrideRule.type);
      if (overrideRule.type === 'lib') {
        remOverride = calcRemLibFlexible(width);
      } else if (overrideRule.type === 'custom') {
        remOverride = calcRemCustom(width);
      } else if (overrideRule.type === 'pc') {
        remOverride = calcRemPcResize(parentWidth);
      } else {
        // 未识别的类型：对 customRoutes 命中的路由兜底用 calcRemCustom，其余保持 lib-flexible
        remOverride = useCustomCalculation ? calcRemCustom(width) : calcRemLibFlexible(width);
      }
      // override 生效时开启“根字号锁”，避免被页面内逻辑覆盖（如某些页面 created() 手动设置 html fontSize）
      applyRootFontSize(remOverride, true);
      return;
    }

    // 2) pcResize 路由：直接按 pcResize 规则计算，并且用 body.clientWidth 对齐取宽方式
    // 这里不加“根字号锁”，保持与 pcResize 的行为一致；但由于两边公式一致，不会出现字号跳变。
    if (usePcCalculation) {
      var pcWidth = (doc.body && doc.body.clientWidth) || parentWidth || width;
      var remPc = calcRemPcResize(pcWidth);
      applyRootFontSize(remPc, false);
      return;
    }

    var rem;
    // 使用 自定义 的计算规则
    if (useCustomCalculation) {
      rem = calcRemCustom(width);
    } else {
      rem = calcRemLibFlexible(width);
    }
    // console.log('rem', rem);
    // console.log('docEl===', docEl);

    applyRootFontSize(rem, false);
  }

  win.addEventListener(
    'resize',
    function () {
      clearTimeout(tid);
      // console.log('docEl', docEl);
      tid = setTimeout(refreshRem, 300);
    },
    false,
  );
  win.addEventListener(
    'pageshow',
    function (e) {
      if (e.persisted) {
        clearTimeout(tid);
        tid = setTimeout(refreshRem, 300);
      }
    },
    false,
  );

  if (doc.readyState === 'complete') {
    doc.body.style.fontSize = 12 * dpr + 'px';
  } else {
    doc.addEventListener(
      'DOMContentLoaded',
      function () {
        doc.body.style.fontSize = 12 * dpr + 'px';
      },
      false,
    );
  }

  refreshRem();

  flexible.dpr = win.dpr = dpr;
  flexible.refreshRem = refreshRem;
  flexible.rem2px = function (d) {
    var val = parseFloat(d) * this.rem;
    if (typeof d === 'string' && d.match(/rem$/)) {
      val += 'px';
    }
    return val;
  };
  flexible.px2rem = function (d) {
    var val = parseFloat(d) / this.rem;
    if (typeof d === 'string' && d.match(/px$/)) {
      val += 'rem';
    }
    return val;
  };

  // 添加路由变化监听（用于 SPA 应用）
  // 监听 popstate 事件（浏览器前进/后退）
  win.addEventListener(
    'popstate',
    function () {
      refreshRem();
    },
    false,
  );

  // 提供全局方法供 Vue Router 等调用
  win.flexibleRouteChange = function () {
    refreshRem();
  };

  /**
   * 临时覆盖 rem 规则（用于弹窗/嵌套组件不受路由规则影响）
   *
   * @param {'lib'|'custom'|'pc'} type
   * @returns {string} token 用于 pop
   */
  win.flexibleOverridePush = function (type, parentWidth) {
    var token = 'remRule_' + Date.now() + '_' + Math.random().toString(16).slice(2);
    remRuleStack.push({ token: token, type: type });
    refreshRem(parentWidth);
    return token;
  };

  /**
   * 退出覆盖 rem 规则（按 token 精确移除）
   */
  win.flexibleOverridePop = function (token) {
    if (!token) return;
    for (var i = remRuleStack.length - 1; i >= 0; i--) {
      if (remRuleStack[i].token === token) {
        remRuleStack.splice(i, 1);
        break;
      }
    }
    refreshRem();
  };

  /**
   * 清空所有 rem 覆盖规则（用于跨路由跳转时，避免 keep-alive 组件残留的 override 影响新页面）
   * 注意：这里不主动 refreshRem，交给路由 afterEach 或调用方在 URL 更新后再刷新
   */
  win.flexibleOverrideClearAll = function () {
    remRuleStack.length = 0;
    unlockRootFontSize();
  };
})(window, window['lib'] || (window['lib'] = {}));



// WEBPACK FOOTER //
// ./src/utils/flexible.js